import { render } from "./ItemPage.vue?vue&type=template&id=2beddf84&scoped=true"
import script from "./ItemPage.vue?vue&type=script&lang=js"
export * from "./ItemPage.vue?vue&type=script&lang=js"

import "./ItemPage.vue?vue&type=style&index=0&id=2beddf84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2beddf84"]])

export default __exports__